import { useTranslation } from 'react-i18next';

import {
  StyledContentWrapper,
  StyledFakeInput,
  StyledFakeInputLabel,
  StyledLine,
  StyledMessage,
  StyledTextEllipsis,
} from '~/components/atoms/mockup-previews/email-mockup/styled';

import { StyledMockupWrapper } from './styled';

type WhatsappMockupProps = {
  number: string;
  message: string;
};

export function WhatsappMockup({ number, message }: WhatsappMockupProps) {
  const { t } = useTranslation();

  return (
    <StyledMockupWrapper>
      <StyledContentWrapper>
        <StyledFakeInputLabel>{t('staticQrTemplates:sms:mockup:number')}</StyledFakeInputLabel>
        <StyledFakeInput>
          <StyledTextEllipsis>{number}</StyledTextEllipsis>
        </StyledFakeInput>
        <StyledFakeInputLabel>{t('staticQrTemplates:sms:mockup:message')}</StyledFakeInputLabel>
        <StyledLine />
        <StyledMessage>{message}</StyledMessage>
      </StyledContentWrapper>
    </StyledMockupWrapper>
  );
}
